
export default {
  path: 'event-access',
  component: () => import(/* webpackChunkName: "event" */ './eventAccess.vue'),
  children: [
    {
      path: '/',
      name: 'event.access-config',
      component: () => import('./accessConfig.vue')
    },
    {
      path: 'login/:type',
      name: 'event.login',
      component: () => import('./eventLogin.vue')
    }
  ],
}
